import React, { useState, useEffect } from 'react'
import { Box, Paper, Text, Flex, Button, Divider, Group, Modal } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import TableUserRelation from './TableUserRelation'
import FormAdjustRelation from './FormAdjustRelation'
import LoadingData from '../../../../ui/LoadingData'
import NoData from '../../../../ui/NoData'
import { deleteUserRelation } from '../../../../../services/users'
import { modalDeleteData } from '../../../../ui/Prompt/modalDeleteData'
import { getUserDetail } from '../../../../../store/userDetail'
import { useParams } from 'react-router-dom'

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Name',
    width: 200
  },
  {
    label: 'Relation',
    width: 'auto'
  },
  {
    label: 'Relation Date',
    width: 'auto'
  },
  {
    label: 'Order',
    width: 'auto'
  },
  {
    label: 'Membership',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const UserRelations = () => {
  const params = useParams()
  const userId = params.id
  const dispatch = useDispatch()
  const { isLoadingUser, childs, referralAgent, referralClient } = useSelector((state) => state.user_detail)
  const [userRelationList, setUserRelationList] = useState([])
  const [openModalForm, setOpenModalForm] = useState(false)

  useEffect(() => {
    handleGetListUserRelations()
    // eslint-disable-next-line
  }, [])

  const handleGetListUserRelations = () => {
    const data = [
      ...childs,
      ...referralAgent,
      ...referralClient
    ]
    setUserRelationList(data)
  }


  const actions = {
    delete: (val) => {
      modalDeleteData('User Relation', val.id, val.name, deleteUserRelation, () => dispatch(getUserDetail(userId)))
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
  }

  const handlingCountOrder = (dataRelation) => {
    if (!dataRelation || dataRelation.length === 0) {
      return 0
    }
    const countOrder = dataRelation.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.total_orders
    }, 0)

    return countOrder
  }

  return (
    <Box>
      <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
        <Text fw={500}>
          User Relations
        </Text>
        <Divider my='xs' />
        <Flex justify='flex-end'>
          <Button size='xs' onClick={() => setOpenModalForm(true)}>Add Relation</Button>
        </Flex>
        <Box my={30}>
          <Box>
            <Group mb={2} gap='xs'>
              <Text fz={12}>Member Total: </Text>
              <Text fz={12} fw='bold'>{userRelationList.length} Member</Text>
            </Group>
            <Group mb={10} gap='xs'>
              <Text fz={12}>Order Total: </Text>
              <Text fz={12} fw='bold'>{handlingCountOrder(userRelationList)} Orders</Text>
            </Group>
          </Box>
          {isLoadingUser ? <LoadingData /> : userRelationList.length > 0 ? <TableUserRelation label={labelTable} data={userRelationList} actionMethod={handleAction}  /> : <NoData />}
        </Box>
      </Paper>
      <Modal
        opened={openModalForm}
        onClose={onCloseModalForm}
        centered
        closeOnClickOutside={false}
        size='lg'
        title={<Text fw='Bold'>Add User Relation</Text>}
        withCloseButton={false}
      >
        <FormAdjustRelation
          onCloseForm={onCloseModalForm}
        />
      </Modal>
    </Box>
  )
}

export default UserRelations